import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const QrBarcode = async (data) => {
  let response = null;
  try {
    response = await axios.post(
      webView ? `/barcode/ajax/new${banner}` : `/barcode/ajax/new`,
      {
        link: data[0],
        qrTitle: data[2],
        gtinCode: data[3],
        typeBarcode:data[4],
        token: token,
        ...(data[1] !== "" && { advertisingIabCategories: data[1] })
      }
    );
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const QrBarcodeEdit = async (data) => {
  let response = null;
  try {
    response = await axios.post(`/barcode/ajax/edit/${data[0]}`, {
      link: data[1],
      ...(data[2] !== "" && { advertisingIabCategories: data[2] }),
      qrTitle: data[3],
      gtinCode: data[4],
      typeBarcode:data[5],
      token: token,
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};
